module.exports = __webpack_public_path__ + "static/img/3.a056c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/3.png
// module id = llh6
// module chunks = 2